import React, {Link, Switch, Route} from "react-router-dom";
import './App.css';
import YouTubeForm from "./components/YouTubeForms"


import thanyou from "./components/thankyou"




function App() {
  return (
    <div className="App">
      <nav>
      <Link to="/thankyou">Thank You</Link>
      </nav>
      <Switch>
        <Route exact path ="/thankyou" component={thanyou} />
        
      </Switch>
      
      <YouTubeForm />
      

    </div>
  );
}

export default App;
